class VanillaVisitedLoading {
  constructor(options = {}) {
    this.pageSelector = options.pageSelector || "#js-page";
    this.loadingSelector = options.loadingSelector || "#js-loading";

    this.storageKey = options.storageKey || "entersology_visited";
    this.visitedClass = options.visitedClass || "--is-visited";

    this.page = document.querySelector(this.pageSelector);
    this.loading = document.querySelector(this.loadingSelector);

    this.handleBeforeLeave = this.handleBeforeLeave.bind(this);

    this.init();
  }

  init() {
    if (!this.page) return;

    if (this.hasVisited()) {
      this.addVisitedClass();
      this.bindEvents();
      return;
    }

    this.setVisited();
    this.bindEvents();
  }

  bindEvents() {
    window.addEventListener(
      "barba:before-leave",
      this.handleBeforeLeave,
      false,
    );
  }

  handleBeforeLeave() {
    /**
     * 初回訪問後、Barbaで別ページへ遷移するタイミングで
     * #js-page に --is-visited を付与する
     */
    this.setVisited();
    this.addVisitedClass();
  }

  addVisitedClass() {
    if (!this.page) return;

    this.page.classList.add(this.visitedClass);
  }

  hasVisited() {
    try {
      return window.sessionStorage.getItem(this.storageKey) === "true";
    } catch (error) {
      return false;
    }
  }

  setVisited() {
    try {
      window.sessionStorage.setItem(this.storageKey, "true");
    } catch (error) {
      return;
    }
  }

  reset() {
    try {
      window.sessionStorage.removeItem(this.storageKey);
    } catch (error) {
      return;
    }
  }

  destroy() {
    window.removeEventListener(
      "barba:before-leave",
      this.handleBeforeLeave,
      false,
    );
  }
}

export default VanillaVisitedLoading;
